import(/* webpackMode: "eager" */ "/app/app/banking/page.jsx");
